'use strict';

frontendApp.factory('ProcessingStatsService', ['$resource', '$rootScope', 'ConfigService', 'ResourceWrapperService', function ($resource, $rootScope, ConfigService, ResourceWrapperService) {

  var _service = {};

  var RawStatsResource = $resource(ConfigService.getServerBaseUrlForResource() + '/project/:projectId/collection/:collectionId/processingStats',
    {'id': '@id', 'projectId': '@projectId', 'collectionId': '@collectionId'});

  var Stats = ResourceWrapperService.WrapActions(RawStatsResource);


  _service.findAll = function (projectId, collectionId, callback) {
    return Stats.query({projectId: projectId, collectionId: collectionId}, function (stats) {
      if (callback) callback(stats);
    });
  };

  return _service;

}]);
